import React, { useState, useContext } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classes from "./NavBarComponent.module.css";
import MenuComponent from "./MenuComponent";
import Applauselogo from "./pages/Images/applause.png";
import PermissionContext from ".././Store/permission-context";
import Headroom from "react-headroom";
import {
  faBars,
  faTimes,
  faCaretDown,
} from "@fortawesome/fontawesome-free-solid";

const NavBarComponent = () => {
  const PCtx = useContext(PermissionContext);
  const [logger, setlogger] = useState(PCtx.logged);
  const [isMobile, setIsMobile] = useState(false);

  return (
    <nav className={classes.nav_style}>
      <img src={Applauselogo} alt="logo" className={classes.Applauselogo} />

      <div className={classes.waviy}>
        <span>A</span>
        <span>P</span>
        <span>P</span>
        <span>L</span>
        <span>A</span>
        <span>U</span>
        <span>S</span>
        <span>E</span>
      </div>

      <MenuComponent isM={isMobile} />

      <Button
        variant="outline-secondary"
        className={classes.mobileBarTimes}
        onClick={() => setIsMobile(!isMobile)}
      >
        {isMobile ? (
          <FontAwesomeIcon icon={faTimes} style={{ color: "white" }} />
        ) : (
          <FontAwesomeIcon icon={faBars} style={{ color: "white" }} />
        )}
      </Button>
    </nav>
  );
};

export default NavBarComponent;
